import {Button, Input} from "antd";
import React, {useEffect, useState} from "react";
import "./emailSignUp.css";
import {useHistory} from "react-router";
import {Http} from "../../../../helpers/axois";
import {useToast} from "../../../../helpers/commonFunction";
import {decode} from 'jsonwebtoken'
import {useDispatch} from "react-redux";
import {saveDetails, setUser} from "../../../../stateManager/store/user/actions";
import { redirectOnLogin } from "../../../../helpers/util";
interface Iprops {
    // setLoginState: (state: string) => void;
}
const EmailSignUp = (props: Iprops) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {SuccessToast, ErrorToast} = useToast();
    const [ validationPopup, setValidationPopup ] = useState(false);
    const [ password, setPassword ] = useState('');
    const [isValidPassword, setIsValidPassword] = useState(true);
    const [validatedPassword, setValidatedPassword] = useState('')
    const [ signUpCredentials, setSignUpCredentials ] = useState({
        firstName: '',
        lastName: '',
        userName: '',
        email: '',
        password: ''
    })
    const [ emptyError, setEmptyError ] = useState<string[]>([]);


    const handleChange = (valueKey: string) => (e: any) => {
        setEmptyError([])
        const {value} = e.target;
        setSignUpCredentials(prevState => ({
            ...prevState,
            [ valueKey ]: value
        }));
    };

    const handleSignUp = () => {
        const isBetween_8_to_40 = password.length >= 8 && password.length <= 40;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasSpecialCharacter = /[!@#$%^&*()_+{}\[\]:;<>,.?~\-]/.test(password);
        const hasNumber = /\d/.test(password);

        if (password.length && isBetween_8_to_40 && hasUpperCase && hasLowerCase && hasSpecialCharacter && hasNumber) {
            setIsValidPassword(true)
        } else if (password.length) {
            setIsValidPassword(false)
            let passwordIndex = emptyError.indexOf("password");
            if (passwordIndex !== -1) {
                emptyError.splice(passwordIndex, 1);
            }
            return;
        }
        if (signUpCredentials?.userName !== '' && signUpCredentials.email !== '' && password !== '') {
            let finalCredentials = {
                firstName: signUpCredentials.firstName,
                lastName: signUpCredentials.lastName,
                userName: signUpCredentials.userName,
                email: signUpCredentials.email,
                password: password
            }
            try {
                Http.post("signUp", finalCredentials).subscribe(
                    (res: any) => {
                        let {firstName, email, lastName, userName} = res
                        const decoded = decode(res.token);
                        dispatch(setUser({user: decoded}));
                        localStorage.setItem("studioToken", res.token);
                        localStorage.setItem("studioRefreshToken", res.refreshToken);
                        if(redirectOnLogin(res.token)) {
                            return
                        }
                        history.push("/select-onboarding");
                        SuccessToast('Registered Successfully')
                        dispatch(saveDetails({
                            firstName, email,
                            lastName: lastName,
                            userName: userName,
                        }));
                        // window.location.reload();
                    },
                    err => {
                        ErrorToast(err.message)
                    }
                );
            } catch (e) {
            }
        } else {
            if (signUpCredentials?.userName === '' && signUpCredentials.email === '' && password === '') {
                setEmptyError([ 'all' ])
            } else {
                if (signUpCredentials.userName === '') {
                    setEmptyError((prev: any) => ([ ...prev, 'userName' ]))
                }
                if (password === '') {
                    setEmptyError((prev: any) => ([ ...prev, 'password' ]))
                }
                if (signUpCredentials.email === '') {
                    setEmptyError((prev: any) => ([ ...prev, 'email' ]))
                }
            }
        }
    };

    const validationChecklist = () => {
        // validation
        const isBetween_8_to_40 = password.length >= 8 && password.length <= 40;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasSpecialCharacter = /[!@#$%^&*()_+{}\[\]:;<>,.?~\-]/.test(password);
        const hasNumber = /\d/.test(password);

        return (
            <>
                <div style={{top: "420px"}} className="popUp-box zoom-in-animation">
                    <div className="arrow"></div>
                    <div className="inside-popup">
                        <div className="popup-title" >Must have at least 8 characters.</div>
                        <div style={{borderTop: "0.75px dashed rgba(217, 217, 217, 1)", marginTop: "10px", marginBottom: "10px", height: "2px", width: "100%"}} ></div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}} >
                            <div style={{marginBottom: "10px", color: "rgba(108, 108, 108, 1)", fontSize: "14px", fontWeight:400 }} >It’s better to have</div>
                            <div style={{marginBottom:"10px", marginLeft: "10px", display: "flex", alignItems: "center"}}>
                                <div style={{height: "6px", width: "6px", borderRadius: "25px", background: (hasUpperCase && hasLowerCase) ? "rgba(0, 185, 118, 1)" : "rgba(217, 217, 217, 1)"}}></div>
                                <div style={{marginLeft: "11px",fontWeight:400,  color: (hasUpperCase && hasLowerCase) ? "rgba(0, 185, 118, 1)" : "rgba(108, 108, 108, 1)", fontSize: "14px", }}>Upper & lower case letters</div>
                            </div>
                            <div style={{marginBottom:"10px", marginLeft: "10px", display: "flex", alignItems: "center"}}>
                                <div style={{height: "6px", width: "6px", borderRadius: "25px", background: hasSpecialCharacter ? "rgba(0, 185, 118, 1)" : "rgba(217, 217, 217, 1)"}}></div>
                                <div style={{marginLeft: "11px", color: hasSpecialCharacter ? "rgba(0, 185, 118, 1)" : "rgba(108, 108, 108, 1)", fontWeight:400, fontSize: "14px", }}>A symbol(#$&@!^%*)</div>
                            </div>
                            <div style={{marginLeft: "10px", display: "flex", alignItems: "center"}}>
                                <div style={{height: "6px", width: "6px", borderRadius: "25px", background: hasNumber ? "rgba(0, 185, 118, 1)" : "rgba(217, 217, 217, 1)"}}></div>
                                <div style={{marginLeft: "11px", color: hasNumber ? "rgba(0, 185, 118, 1)" : "rgba(108, 108, 108, 1)", fontWeight:400, fontSize: "14px"}}>A Number (0-9)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className="signUp-container" style={{position: "relative"}} >
            <div className="heading">Sign Up</div>
            <div className="subtext">Create an account with your email.</div>
            <div style={{display: "flex", width: "100%", marginBottom: "24px"}}>
                <Input onChange={handleChange('firstName')} style={{fontWeight:400, width: "50%", marginRight: "8px"}} className="custom-input" placeholder="First Name" ></Input>
                <Input onChange={handleChange('lastName')} style={{width: "50%"}} className="custom-input" placeholder="Last Name" ></Input>
            </div>
            <div style={{marginBottom: "24px"}}>
                <Input onChange={handleChange('userName')} style={{fontWeight:400, borderColor: (emptyError[ 0 ] === 'all' || emptyError?.includes('userName')) ? "rgba(235, 0, 27, 1)" : '#D9D9D9'}} className="custom-input" placeholder="Username*" ></Input>
                {(emptyError[ 0 ] === 'all' || emptyError?.includes('userName')) && <div style={{color: "rgba(235, 0, 27, 1)", fontSize: "13px", fontWeight: 400}}>Please enter user name</div>}
            </div>
            <div style={{marginBottom: "24px"}}>
                <Input onChange={handleChange('email')} style={{fontWeight:400, borderColor: (emptyError[ 0 ] === 'all' || emptyError?.includes('email')) ? "rgba(235, 0, 27, 1)" : '#D9D9D9'}} className="custom-input" placeholder="Email*" ></Input>
                {(emptyError[ 0 ] === 'all' || emptyError?.includes('email')) && <div style={{color: "rgba(235, 0, 27, 1)", fontSize: "13px", fontWeight: 400}}>Please enter email</div>}
            </div>
            <div style={{marginBottom: "42px"}}>
                <Input.Password
                    onClick={() => setValidationPopup(true)}
                    onBlur={() => setValidationPopup(false)}
                    onChange={(e) => {setIsValidPassword(true); setPassword(e.target.value);}} style={{border: (emptyError[ 0 ] === 'all' || emptyError?.includes('password')) ? "1px solid rgba(235, 0, 27, 1)" : '1px solid #D9D9D9'}} className="custom-input-password" placeholder="Password" ></Input.Password>
                {(emptyError[ 0 ] === 'all' || emptyError?.includes('password')) && <div style={{color: "rgba(235, 0, 27, 1)", fontSize: "13px", fontWeight: 400}}>Please enter password</div>}
                {!isValidPassword && !emptyError?.includes('password') && <div style={{color: "rgba(235, 0, 27, 1)", fontSize: "13px", fontWeight: 400}}>Password fails to meet policy requirements.</div>}
            </div>
            {validationPopup && validationChecklist()}
            <Button onClick={handleSignUp} className="signUp-button">Sign Up</Button>
            <div className="terms-text">
                <p style={{fontSize:"13px", fontWeight:400, color:"rgba(108, 108, 108, 1)"}} >By continuing, you agree to our <a href="https://autonom8.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="terms-link">Terms of Service & Privacy Policy</a></p>
            </div>
            <div style={{borderTop: "0.75px dashed rgba(217, 217, 217, 1)", height: "2px", width: "370px"}} ></div>
            <div style={{ marginTop: "20px", fontSize: "14px", fontWeight: 400, color: "#6C6C6C" }} >Already have an account? <span onClick={() => history.push('/signin/email-signIn')} style={{ fontSize: "16px", fontWeight: 600, cursor: "pointer", color: "#052F35"}}>Sign In</span></div>
        </div>
    )
}

export default EmailSignUp;
